import { FC, Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { TableLayout } from "Layouts";
import { ControlledTable, Filter2 } from "Components";
import { TableCol, actionArr, FilterArr } from "./Data";
import { RouteUrls } from "Constant/RouteUrls";
import PatientApi from "Service/Patient.api";
import { Filter2DataProps } from "DataTypes/Common";
import Formate from "./Formate";
import { useDispatch } from "react-redux";
import { ScreenInitialStateType } from "DataTypes/Redux";
import { EligibleType } from "DataTypes/Services/Patient.type";
import {
  CreateFilter2Payload,
  RedoxDataToFilter,
  TransformFilterDataRedox,
} from "Utils/common";
import { setPageFilter, setPageLimit } from "Redux/Screen/Action";
import UI from "Constant/UI";

const Eligible: FC = () => {
  const dispatch = useDispatch();
  const { listPagination, listFilters }: ScreenInitialStateType = useSelector(
    (state: any) => state?.screen
  );
  const listObj = listFilters.find(el => el.id == "eligible");
  const reduxLimit = (listPagination || []).find(
    el => el.id == "eligible"
  )?.limit || 10;
  const permission: any = useSelector(
    (state: any) => state?.user?.myPermission?.eligiblepatient
  );
  const navigate = useNavigate();
  const [rows, setRows] = useState<EligibleType[]>([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    ...UI.pageData,
    limit: reduxLimit
  });
  const [searchText, setSearchText] = useState("");
  const [filterHeight, setFilterHeight] = useState<number>(0);
  const [filterData, setFilterData] = useState<Filter2DataProps[]>(() =>
    RedoxDataToFilter(
      JSON.parse(JSON.stringify(FilterArr())),
      listObj
    )
  );
  const tableHeight = `calc(99% - ${filterHeight}px)`;

  useEffect(() => {
    handleSetData(1, pageData.limit);
  }, [filterData]);

  const handleSetData: (
    currentPage: number,
    currentLimit: number
  ) => void = async (currentPage, currentLimit) => {
    setLoading(true);
    const newFilterPayload = CreateFilter2Payload(filterData);
    const payload = {
      ...(newFilterPayload || {}),
    };
    const res: any = await PatientApi.Eligible({
      offset: (currentPage - 1) * currentLimit,
      limit: currentLimit,
      data: payload,
    });
    let newPageData = { ...UI.pageData }
    let newRows: EligibleType[] = [];
    if (res?.success) {
      newRows = Formate.EligibleList(res?.data);
      newPageData = res.criterion
    }
    setRows(newRows);
    setPageData(newPageData)
    dispatch(setPageLimit({ id: "eligible", limit: newPageData.limit }));
    dispatch(setPageFilter({
      id: "eligible",
      filterData: TransformFilterDataRedox(filterData)
    }));
    setLoading(false);
  };

  const handlePatientDetails: (data: EligibleType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}/${RouteUrls.details}`
    );
  };

  const handleChart: (data: EligibleType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.clinicalSummary}`
    );
  };

  const handleTask: (data: EligibleType) => void = (data) => {
    navigate(
      `../../${RouteUrls.patient}/${data.patientId}` +
      `/${RouteUrls.task}/${RouteUrls.add}`
    );
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol}
      tableRow={rows}
      tableAction={(data: EligibleType) => {
        return actionArr(
          () => handleChart(data),
          () => handlePatientDetails(data),
          () => handleTask(data),
        );
      }}
      searchText={searchText}
    />
  );

  return (
    <Fragment>
      <Filter2
        filterDataArr={filterData}
        handleFilterClick={(data) => setFilterData(data)}
        changeSearchText={(val) => setSearchText(val)}
        setFilterHeight={(val) => setFilterHeight(val)}
      />
      {permission?.search && (
        <TableLayout
          tblBody={TblBodyJSX}
          loading={loading}
          tblHead={ControlledTable.TblHead(TableCol)}
          height={tableHeight}
          Pagination={
            <ControlledTable.Pagination
              mainPage={pageData.page}
              limit={pageData.limit}
              total={pageData.total}
              handleClick={handleSetData}
              tableStyle={true}
            />
          }
        />
      )}
    </Fragment>
  );
};

export default Eligible;
